import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import { adminSideLinks } from '../adminRoutes';

function AdminJobsPage() {
  return (
    <DashboardShell role="ADMIN" sideLinks={adminSideLinks}>
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-navy">Jobs</h1>
        <p className="mt-2 text-sm text-slate-600">Review job listings, flags, and moderation status.</p>
      </div>
    </DashboardShell>
  );
}

export default AdminJobsPage;
